import { GET_HORSE_RACEING_RESULT, GET_HORSE_RACEING_RESULT_SUCCESS, GET_HORSE_RACEING_RESULT_FAILURE, GET_HIPPODROME_HORSE_RACEING_RESULT, GET_HIPPODROME_HORSE_RACEING_RESULT_FAILURE, GET_HIPPODROME_HORSE_RACEING_RESULT_SUCCESS, GET_HIPPODROME_HORSE_RACEING_RUN_RESULT, GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_SUCCESS, GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_FAILURE } from 'Store/constants';

const initialState = {
  dateResults: {
    data: [],
    selectedLeg: {},
    isLoading: false,
    error: null
  },
  hippodromeResult: {
    data: [],
    isLoading: false,
    error: null,
  },
  raceRunResults: {
    data: [],
    isLoading: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACEING_RESULT:
      return { ...state, dateResults: { ...state.dateResults, isLoading: true, error: null } };
    case GET_HORSE_RACEING_RESULT_SUCCESS:
      return { ...state, dateResults: { ...state.dateResults, data: action.payload, isLoading: false, error: null } };
    case GET_HORSE_RACEING_RESULT_FAILURE:
      return { ...state, dateResults: { ...state.dateResults, isLoading: false, error: action.payload } };

    case GET_HIPPODROME_HORSE_RACEING_RESULT:
      return { ...state, hippodromeResult: { ...state.hippodromeResult, isLoading: true, error: null } };
    case GET_HIPPODROME_HORSE_RACEING_RESULT_SUCCESS:
      return { ...state, hippodromeResult: { ...state.hippodromeResult, data: action.payload, isLoading: false, error: null } };
    case GET_HIPPODROME_HORSE_RACEING_RESULT_FAILURE:
      return { ...state, hippodromeResult: { ...state.hippodromeResult, isLoading: false, error: action.payload } };

    case GET_HIPPODROME_HORSE_RACEING_RUN_RESULT:
      return { ...state, raceRunResults: { ...state.raceRunResults, isLoading: true, error: null } };
    case GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_SUCCESS:
      return { ...state, raceRunResults: { ...state.raceRunResults, data: action.payload, isLoading: false, error: null } };
    case GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_FAILURE:
      return { ...state, raceRunResults: { ...state.raceRunResults, isLoading: false, error: action.payload } };

    default:
      return state;
  }
};